module.exports = __webpack_public_path__ + "img/P03-PA-129070.4357c565.jpg";